import styled from "styled-components";

export const HelpText = styled.small`
  display: block;
  color: #656565;
  margin-top: 0.2rem;
`;
